import React, { useState } from "react";
import { motion } from "framer-motion";
import { Grid, TextField, Button as MuiButton } from "@mui/material";
import Select from "./Select";
import { Search, X } from "lucide-react";
import useFieldChoices from "../../hooks/useFieldChoices";

const SearchFilter = ({ searchFilters, setSearchFilters }) => {
  // const {fieldChoices} = useFieldChoices()
  const handleFilterChange = (field, value) => {
    setSearchFilters((prev) => ({ ...prev, [field]: value }));
  };
  const hasActiveFilters =
    searchFilters.pilot_type || searchFilters.total_flight_hours;
  return (
    <motion.form
      //   onSubmit={handleSearch}
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.4, duration: 0.8, ease: "easeOut" }}
      className="w-full max-w-3xl mx-auto bg-white/10 backdrop-blur-md p-2 mt-10 rounded-xl shadow-2xl border border-white/20"
    >
      <div className="space-y-3 pt-4">
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 4 }}>
            <Select
              value={searchFilters.pilot_type}
              onChange={(value) => handleFilterChange("pilot_type", value)}
              size="small"
              label="Pilot Type"
              options={[
                {
                  label: "Fixed Wing",
                  value: "fixed_wing",
                },
                {
                  label: "Rotatry wing",
                  value: "rotary_wing",
                },
              ]}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 4 }}>
            <TextField
              type="number"
              label="Total Flight Hours"
              size="small"
              value={searchFilters.total_flight_hours}
              onChange={(e) =>
                handleFilterChange("total_flight_hours", e.target.value)
              }
              slotProps={{
                htmlInput: {
                  min: 0,
                },
              }}
            />
          </Grid>

          {/* Search Button */}
          <Grid size={{ xs: 12, sm: 4 }}>
            <MuiButton
              fullWidth
              variant="outlined"
              size="large"
              startIcon={<X size={16} />}
              disabled={!hasActiveFilters}
              sx={{
                height: "40px",
                fontWeight: 500,
                textTransform: "none",
                borderColor: "rgba(0,0,0,0.2)",
                color: "#475569",
                "&:hover": {
                  borderColor: "#94a3b8",
                  backgroundColor: "rgba(0,0,0,0.03)",
                },
              }}
              onClick={() =>
                setSearchFilters((prev) => ({
                  ...prev,
                  total_flight_hours: "",
                  pilot_type: "",
                }))
              }
            >
              Reset Filters
            </MuiButton>
          </Grid>
        </Grid>
        <div className="grid md:grid-cols-12 gap-2 items-center border-t border-white/10 pt-3"></div>
      </div>
    </motion.form>
  );
};

export default SearchFilter;
